define('orderDetailCompositionView',[
  'module',
  'marionette',
  'settings',
  'app',
  'backbone',
  'jquery',
  'bootbox',
  'noItemsView',
  'template!orderCompositionTabTpl',
  'template!orderCompositionItemTpl',
  'compuzzProUtils',
  'underscore',
  'rolesMixin',
  'vectorizationCollectionView',
  'similarCollectionView',
  'googleImageCollectionView',
  'ordersDetailCompositionProofsheetView',
  'orderPicturesTabPictureCollectionView',
  'ordersDetailOrderClientImagesView',
  'entities/orders',
  'entities/composition_vectorization',
  'entities/pim_product'
], function (
  module,
  Marionette,
  Settings,
  App,
  Backbone,
  $,
  bootbox,
  NoItemsView,
  compositionTabTpl,
  compositionItemTpl,
  CompuzzProUtils,
  _,
  RolesMixin,
  VectorizationCollectionView,
  SimilarCollectionView,
  GoogleImageCollectionView,
  CompositionProofsheetView,
  OrderPicturesView,
  ImagesView
) {
  'use strict';

  var CompositionItemView = Marionette.LayoutView.extend({
    letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q',
      'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    template: compositionItemTpl,

    ui: {
      compositionImg: '.composition-img',
      useBackgroundColor: '.useBackgroundColor',
      jsLoader: '.js-loading-block',
      btnLoadGoogleImage: '.btn-load-google-images'
    },

    regions: {
      vectorizationRegion: '.vectorization-region',
      similarRegion: '.similar-region',
      googleImageRegion: '.google-image-region'
    },

    events: {
      'click .btn-edit-compuzzpro': 'onCompuzzProEditClick',
      'change @ui.useBackgroundColor': 'onChangeUseBackgroundColor',
      'click .btn-edit-property': 'onClickEditProperty',
      'click .btn-delete-print-area': 'onDeletePrintArea',
      'click @ui.btnLoadGoogleImage': 'onLoadGoogleImages',
      'click .btn-check-stroke': 'onCheckStrokeClick'
    },

    onCheckStrokeClick: function () {
      this.checkStroke = true;
      $.ajax({
        url: Settings.url('compuzz2', 'personalization.json/compositions/' + this.model.get('secId') + '/checkstroke', {
          strokeWidth: this.minStrokeWidth,
          strokeLength: this.minStrokeWidth,
          strokeWidthTexts: this.minStrokeWidth,
          strokeLengthTexts: this.minStrokeWidth,
          deviation: 0.3,
          step: 0.3
        }),
        type: 'GET',
        success: _.bind(function (result) {
          if (!result || !result.value) {
            bootbox.alert(_.i18n('common.noStrokeError'));
          }
        }, this),
        error: function () {
        }
      });
      this.render();
    },

    onChangeUseBackgroundColor: function () {
      $('.loading-block').show();
      App.request('order:update-use-background-color', this.model.collection.orderModel.get('purchaseOrderId'), this.model.get('secId'),
        this.ui.useBackgroundColor.prop('checked')).then(_.bind(function () {
        CompuzzProUtils.getInstance().trigger('notificationCenter:compuzzProRefreshComposition');
        $('.loading-block').hide();
      }, this));
    },

    forceNotDesign2: false,

    onRender: function () {
      $.material.init();
      var useBackgroundColor = this.model.get('useBackgroundColor') || false;
      this.ui.useBackgroundColor.prop('checked', useBackgroundColor);
      /*
      if (this.forceNotDesign2 || !Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_DESIGN2] ||
        this.model.collection.orderModel.get('commandType') === 'offer') {
        var col = App.request('composition-vectorization:get-collection', this.model.get('secId'));
        col.fetch();
        this.vectorizationsView = new VectorizationCollectionView({
          collection: col
        });

        this.getRegion('vectorizationRegion').show(this.vectorizationsView);

        var col2 = App.request('composition-similar:get-collection', this.model.get('secId'));
        col2.fetch();
        this.similarsView = new SimilarCollectionView({
          collection: col2
        });

        this.getRegion('similarRegion').show(this.similarsView);
      }
       */
    },

    onLoadGoogleImages: function () {
      this.ui.jsLoader.show();
      this.ui.btnLoadGoogleImage.hide();
      var col3 = App.request('composition-google-image:get-collection', this.model.get('secId'));
      col3.fetch().done(_.bind(function () {
        this.googleImagesView = new GoogleImageCollectionView({
          collection: col3
        });
        this.getRegion('googleImageRegion').show(this.googleImagesView);
      }, this));
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.displayEditButtons = true;
     /* if (this.model.collection.orderModel.get('pim')) {
        templateData.displayEditButtons = false;
      }*/

      if (templateData.exportFileUid) {
        templateData.customExportUrl = Settings.url('file', templateData.exportFileUid) + '&cmds=on';
      } else {
        templateData.exportFileUid = '';
      }

      templateData.printZones = [];

      _.each(templateData.availablePzs, _.bind(function (pz) {
        if (pz.colorModeType !== 'spot') {
          pz.maxColors = '';
        }
        if (pz.colorModeType === 'quadri') {
          pz.digital = true;
        } else {
          pz.digital = '';
        }
        if (pz.colorModeType === 'fixedFilling') {
          pz.eng = true;
        } else {
          pz.eng = '';
        }

        pz.productionTime = '';
        if(pz.productionTimes) {
          _.each(pz.productionTimes, function (productionTime) {
            if (productionTime.from && productionTime.to) {
              if(this.model.collection.orderModel.get('quantity') >= productionTime.from &&
                this.model.collection.orderModel.get('quantity') <= productionTime.to) {
                pz.productionTime = '(Production time: ' + productionTime.days + ' days)';
              }
            }
          }, this);
        }
        
      }, this));

      templateData.advancedMode = !!Settings.configValue('advancedMode');
      templateData.orderQuantity = this.model.collection.orderModel.get('quantity') || 0;
      templateData.selectedPzMinQtyExceeded = false;
      if (templateData.advancedMode) {
        var selectedPz = _.findWhere(templateData.availablePzs, {id: this.model.get('pzId')});
        if (selectedPz && selectedPz.minimumQuantity > 1 && selectedPz.minimumQuantity > templateData.orderQuantity) {
          templateData.selectedPzMinQtyExceeded = true;
        }
      }
      templateData.tokenId = Settings.get('tokenId');
      if (Settings.compuzzAwsWsSend) {
        templateData.tokenId += '-v2';
      }
      templateData.customData = this.model.get('customData');
      templateData.prinAreaImgUrl = this.getPrintAreaImgUrl();
      templateData.printAreaName = this.model.get('paName') ? (this.getPrintAreaCode() + ' - ' +
        this.model.get('paName')) : this.getPrintAreaCode();
      templateData.printZone = this.model.get('pzId');

      templateData.compuzzProProtocol = 'cpzp';
      if (Settings.compuzzProProtocol) {
        templateData.compuzzProProtocol = Settings.compuzzProProtocol;
      }
      templateData.editorUrl = Settings.editorUrl;

      if (!this.forceNotDesign2 && Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_DESIGN2] &&
        this.model.collection.orderModel.get('commandType') !== 'offer') {
        templateData.notDesign2 = false;
      } else {
        templateData.notDesign2 = true;
      }

      templateData.displayCheckStroke = false;
      _.each(this.model.collection.productModel.get('printAreas'), _.bind(function (pa) {
        _.each(pa.printZones, _.bind(function (pz) {
          if (pz.id === this.model.get('pzId') && pz.minStrokeWidth) {
            this.minStrokeWidth = pz.minStrokeWidth;
            templateData.displayCheckStroke = true;
          }
        }, this));
      }, this));

      //---------------
      templateData.warning = '';
      var productPz = null;

      var productPa = _.findWhere(this.model.collection.productModel.get('printAreas'), {'id': this.model.get('paId')});
      if (!productPa)
        productPa = _.findWhere(this.model.collection.productModel.get('printAreas'), {'code': this.model.get('paCode')});

      if (productPa) {
        productPz = _.findWhere(productPa.printZones, {'id': this.model.get('pzId')});
        if (!productPz) {
          productPz = _.findWhere(productPa.printZones, {'imppCode': this.model.get('itCode')});
        }
        if (productPz) {
           if (productPz && this.model.get('usedColors') && this.model.get('usedColors').length > productPz.maxColors) {
             templateData.warning = _.i18n('orders.detail.printzones.warning');
             templateData.warning = templateData.warning.replace('%max-colors', productPz.maxColors);
             templateData.warning = templateData.warning.replace('%used-colors', this.model.get('usedColors').length);
           }
        }
      }

      return templateData;
    },

    getPrintAreaCode: function () {
      if (Settings.get('currentCAccount').displayPaCodeLetter) {
        var letter = this.letters[parseInt(this.model.get('paCode'), 10) - 1];
        return letter ? letter : this.model.get('paCode');
      } else {
        return this.model.get('paCode');
      }
    },

    onCompuzzProEditClick: function () {
      CompuzzProUtils.getInstance().sendData({
        value: 'edit compo',
        type: 'compuzzProEditComposition',
        tokenId: Settings.get('tokenId'),
        compositionSecId: this.model.get('secId')
      });
    },

    onDeletePrintArea: function (e) {
      App.request('order:remove-print-zone', this.model.collection.orderModel.get('purchaseOrderId'),
        $(e.target).parent().attr('printzone')).done(_.bind(function () {
        this.model.collection.orderModel.fetch();
      }, this));
    },

    getPrintAreaImgUrl: function () {
      var params = {};
      if (!this.model.get('useBackgroundColor')) {
        params.nobg = true;
      }
      params.productCode = this.model.collection.orderModel.get('productBaseCode');
      params.pac = this.model.get('paCode');
      if (this.checkStroke) {
        if (this.minStrokeWidth) {
          params.strokeWidth = this.minStrokeWidth;
          params.strokeLength = this.minStrokeWidth;
          params.strokeWidthTexts = this.minStrokeWidth;
          params.strokeLengthTexts = this.minStrokeWidth;
        }
        params.checkStroke = true;
      }
      if (Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_DESIGN2]) {
        return Settings.url('x2png', 'compositions/' + this.model.get('secId') + '/snapshot', params);
      } else {
        return Settings.url('x2png', 'compositions/' + this.model.get('secId') + '/snapshot/withMeasure', params);
      }
    }
  });

  var CompositionCollectionView = Marionette.CollectionView.extend({
    childView: CompositionItemView
  });

  var CompositionTabView = Marionette.LayoutView.extend({
    template: compositionTabTpl,
    className: 'content order-personalization',

    ui: {
      txtInternalComment: '.order-internal-comment'
    },

    regions: {
      prinAreaItem: '.js-print-area-container-region',
      proofsheetRegion: '.proofsheet-region',
      additionalVariationImagesRegion: '.js-additional-variation-images-region',
      vrpsRegion: '.vrps-region'
    },

    events: {
      'click .js-delete-custom-export': 'onDeleteCustomExport',
      'click .btn-edit-compuzz': 'onCompuzzEditClick',
      'change @ui.txtInternalComment': 'onInternalCommentChanged',
      'change .itName': 'onPZchange',
      'change .paName': 'onAddPrintArea',
      'click .add-print-area-section': 'onAddPrintAreaClick'
    },

    serializeData: function () {
      var templateData = this.orderModel.toJSON();
      if (templateData.exportFileUid) {
        templateData.customExportUrl = Settings.url('file', templateData.exportFileUid) + '&cmds=on';
      }

      templateData.comment = this.options.productModel.get('comment');
      if (!templateData.comment) {
        templateData.comment = '';
      }

      if (Settings.configValue('orders.showCompuzzVrpOnPimOrder')) {
        templateData.additionalVariationImages = true;
      } else {
        templateData.additionalVariationImages = false;
      }

      templateData.printAreas = [];
      var usedPrintArea = this.options.collection.orderModel.get('compositions');
      _.each(this.printAreas, function (availablePrintArea) {
        var pa = _.findWhere(usedPrintArea, {paId: availablePrintArea.id});
        if (!pa) {
          templateData.printAreas.push(availablePrintArea);
        }
      });

      if (Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_ORDERS_DESIGN2] &&
        this.options.collection.orderModel.get('commandType') !== 'offer') {
        templateData.notDesign2 = false;
      } else {
        templateData.notDesign2 = true;
      }

      return templateData;
    },

    onShow: function () {

      if(this.orderModel.get('pim')) {
        this.pimProduct = App.request('pim:products:model', {id: this.orderModel.get('productSecId')});
        this.pimProduct.fetch().done(_.bind(function () {
          if (this.collection.models.length !== 0) {
            var availablePrAreas = this.options.productModel.get('printAreas');
            _.each(this.collection.models, _.bind(function (model) {
              var pa = _.findWhere(availablePrAreas, {'id': model.get('paId')});
              var availablePrintZones = pa ? pa.printZones : [];

              _.each(availablePrintZones, _.bind(function (pz) {
                var ptMinQty = this.getProductionTimesAndMinimumQuantity(pz.id);
                pz.productionTimes = ptMinQty.productionTimes;
                pz.minimumQuantity = ptMinQty.minimumQuantity;
              }, this));
              model.set('availablePzs', availablePrintZones);
            }, this));

            this.getRegion('prinAreaItem').show(new CompositionCollectionView({collection: this.collection}));
          } else {
            this.getRegion('prinAreaItem').show(new NoItemsView());
          }
        }, this));
      } else {
        if (this.collection.models.length !== 0) {
          var availablePrAreas = this.options.productModel.get('printAreas');

          _.each(this.collection.models, _.bind(function (model) {
            var pa = _.findWhere(availablePrAreas, {'id': model.get('paId')});
            var availablePrintZones = pa ? pa.printZones : [];

            _.each(availablePrintZones, _.bind(function (pz) {
              pz.productionTimes = null;
            }, this));
            model.set('availablePzs', availablePrintZones);
          }, this));

          this.getRegion('prinAreaItem').show(new CompositionCollectionView({collection: this.collection}));
        } else {
          this.getRegion('prinAreaItem').show(new NoItemsView());
        }
      }

      //-----------------
      this.proofsheetView = new CompositionProofsheetView({
        model: this.orderModel
      });
      this.listenTo(this.proofsheetView, 'editCustomProofsheet', this.onCustomProofsheetCompuzzProEditClick);
      this.getRegion('proofsheetRegion').show(this.proofsheetView);

      if (Settings.configValue('orders.showCompuzzVrpOnPimOrder')) {
        this.imagesView = new ImagesView({
          model: this.orderModel,
          product: this.options.productModel
        });
        this.getRegion('additionalVariationImagesRegion').show(this.imagesView);
        this.listenTo(this.imagesView, 'update:complete', function (status,msg) {
          this.showWarning(status,msg);
        });

        var vrpsCollection = new Backbone.Collection();
        if (this.orderModel.get('pim')) {
          this.orderModel.compuzzVrps().then(_.bind(function (vrps) {
            this.urls = this.orderModel.getImageUrls(this.options.productModel, vrps);
            vrpsCollection.reset();
            _.each(this.urls, function (image, index) {
              var model = new Backbone.Model({
                url: image.url,
                secId: image.secId,
                ambiance: image.ambiance,
                index: index,
                orderModel: this.orderModel
              });
              vrpsCollection.add(model);
            }, this);
            this.showVrpsRegion(vrpsCollection);
          }, this));
        } else {
          this.urls = this.orderModel.getImageUrls(this.options.productModel);
          vrpsCollection.reset();
          _.each(this.urls, function (image, index) {
            var model = new Backbone.Model({
              url: image.url,
              secId: image.secId,
              ambiance: image.ambiance,
              index: index,
              orderModel: this.orderModel
            });
            vrpsCollection.add(model);
          }, this);
          this.showVrpsRegion(vrpsCollection);
        }
      }
    },

    getProductionTimesAndMinimumQuantity: function (pzId) {
      var result = {
        productionTimes: null,
        minimumQuantity: null
      };

      if(!this.pimProduct) 
        return result;
     
      if(!this.pimProduct.get('data')) 
        return result;

      if(!this.pimProduct.get('data').get('printAreas')) 
        return result;

      _.each(this.pimProduct.get('data').get('printAreas').models, function (pa) {
        _.each(pa.get('printZones').models, function (pz) {
          if (pz.get('pimId') === pzId) {
            result.productionTimes = pz.get('productionTimes');
            result.minimumQuantity = pz.get('minimumQuantity');
          }
        });
      });        

      return result;
    },

    onCustomProofsheetCompuzzProEditClick: function () {
      CompuzzProUtils.getInstance().sendData({
        value: 'edit compo',
        type: 'compuzzProEditCustomProofsheet',
        tokenId: Settings.get('tokenId'),
        poi: this.orderModel.get('poi')
      });
    },

    showVrpsRegion: function(collection) {
      if (this.getRegion('vrpsRegion')) {
        this.vrpsRegion = new OrderPicturesView({
          collection: collection
        });
        this.getRegion('vrpsRegion').show(this.vrpsRegion);
      }
    },

    showWarning: function (value,msg) {
      if (this.ui && this.ui.warning) {
        if (value) {
          this.ui.warning.show();
          this.ui.warning.text(msg);
        } else {
          this.ui.warning.hide();
        }
      }
    },

    onInternalCommentChanged: function () {
      $('.loading-block').show();
      this.orderModel.set('internalComment', this.ui.txtInternalComment.val());
      $.when(App.request('order:update', {
        purchaseOrderId: this.orderModel.get('purchaseOrderId'),
        internalComment: this.orderModel.get('internalComment')
      })).done(_.bind(function () {
        $('.loading-block').hide();
      }, this));
    },

    onDeleteCustomExport: function (e) {
      $('.loading-block').show();

      // Get the composition ID if available (from data attribute or parent element)
      var compositionId = null;
      if (e && e.currentTarget) {
        compositionId = $(e.currentTarget).data('composition-id');
        if (!compositionId && $(e.currentTarget).closest('.order-composition-tab').length) {
          // If we're in a composition item, try to get the composition ID from the model
          var compositionItem = $(e.currentTarget).closest('.order-composition-tab');
          var compositionIndex = $('.order-composition-tab').index(compositionItem);
          if (compositionIndex >= 0 && this.collection && this.collection.models[compositionIndex]) {
            compositionId = this.collection.models[compositionIndex].get('secId');
          }
        }
      }

      App.request('order:delete-custom-export', this.orderModel.get('purchaseOrderId'), compositionId).then(_.bind(function () {
        this.orderModel.set('exportFileUid', null);
        CompuzzProUtils.getInstance().trigger('notificationCenter:compuzzProRefreshComposition');
        $('.loading-block').hide();
      }, this));
    },

    onCompuzzEditClick: function (e) {
      var printZone = $(e.currentTarget).attr('printZone');
      var poi = this.collection.orderModel.id;
      this.trigger('editor:open', poi, printZone, Settings.editorUrl, this.collection.orderModel.get('pim'));
    },

    onPZchange: function (e) {
      App.request('order:update-printzone', this.orderModel.get('purchaseOrderId'),
        $(e.target).attr('currentPrintzone'),
        $(e.target).find(':selected').val(), null).then(
        _.bind(function () {
          this.orderModel.fetch();
          //window.location.reload();
        }, this)
      );
    },

    onAddPrintAreaClick: function (e) {
      if (!$(e.target).is('select, option')) {
        this.$('.paName').focus();
        var select = this.$('.paName')[0];
        if (select && typeof select.showPicker === 'function') {
          try { select.showPicker(); } catch (err) {}
        }
      }
    },

    onAddPrintArea: function (e) {
      var pa = _.find(this.printAreas, function (pa) {
        return pa.id.toString() === $(e.target).find(':selected').val();
      });
      var pz = pa.printZones[0];
      App.request('order:add-printzone', this.orderModel.get('purchaseOrderId'), pz.id,
          (pz.colorModeType==='spot'?1:undefined)).then(
        _.bind(function () {
          this.orderModel.fetch();
          //window.location.reload();
        }, this)
      );
    }
  });

  module.exports = CompositionTabView;
});

